import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDMY } from "../../utils/date";

const NewsReadPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { newsData } = location.state || {};

  return (
    <div className="bg-white" >
      <div className=" py-4 px-4">
        <div className="row">
          <div className="col-lg-12 col-md-11 col-sm-12">

            {/* Title */}
            <h3 className="heading-part-h1 fw-bold">{newsData?.title}</h3>

            {/* Date */}
            <p className="text-muted">
              <i className="bx bx-calendar"></i> Published on: {formatDMY(newsData?.date)}
            </p>

            {/* Image */}
            <div className="d-flex justify-content-center my-3">
              <img
                src={newsData?.image ? newsData?.image.replace("/thumb", "") : 'assets/images/dummy-news-img.jpeg'}
                alt={newsData?.title}
                className="img-fluid rounded shadow-sm"
                style={{ maxHeight: "600px", objectFit: "cover" }}
                loading="lazy"
              />
            </div>

            {/* Description */}
            <div
              className="full-details-p"
              dangerouslySetInnerHTML={{ __html: newsData?.description }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsReadPage;
